import {Component, ViewChild} from '@angular/core'
import {Role} from '../../models';
import {BsModalComponent} from 'ng2-bs3-modal/ng2-bs3-modal';
import {RolesService} from "../../services/roles.service";
import {ResponseApi} from "../../services/response/response";

@Component({
    moduleId: module.id,
    selector: 'roles',
    templateUrl: 'roles.component.html',
    providers: [RolesService]
})
export class RolesComponent {
    @ViewChild('editRolesModal',{static: false}) editRolesModal: BsModalComponent;
    showLoadScreen:boolean;
    roles: Role[] = [];
    selectedRoleId: number;
    Statuses = [];

    constructor(private rolesService: RolesService) {
        this.rolesService.onStart = () => this.showLoadScreen = true;
        this.rolesService.onEnd = () => this.showLoadScreen = false;
        this.Statuses[1] = "Действующая";
        this.Statuses[2] = "Удаленная";
        this.Statuses[3] = "Заблокированная";
    }

    ngOnInit() {
        this.rolesService.getRoles().subscribe((data: ResponseApi) => this.roles = data.data);
    }

    open(roleId?: number) {
        this.selectedRoleId = roleId;
        this.editRolesModal.open();
    }

    close() {
        this.editRolesModal.close();
    }
}